import axios from "axios";
import constants from "constants";
import { store } from "store";
import errorHandler from "./errorHandler";

/*
    TODO Write a network layer before axios,
    Handle cancellation of network call or ignoring stale response
    Camelize all api keys at deep level
*/

// Add fallback for offlinePaymentServiceUrl if not defined
const baseURL =
  constants.offlinePaymentServiceUrl ||
  "https://staging-payment-offline-service.upgrad.dev";

const offlinePaymentService = axios.create({
  baseURL: `${baseURL}/`,
});
offlinePaymentService.interceptors.request.use((config) => {
  const userInfo = store.getState().userInfo;
  config.headers[constants.authTokenBackendKey] = userInfo.authToken;
  config.headers["sessionID"] = userInfo.sessionId;
  config.headers["redirectToAuth"] = true;
  return config;
});

offlinePaymentService.interceptors.response.use(function (response) {
  return response;
}, errorHandler);

export default offlinePaymentService;
